import { type ReactElement } from 'react'
import { useRequiredParams } from '@util'
import { type WithCompanyId } from '@terros/common'
import { createFileRoute } from '@tanstack/react-router'
import { UserTrash } from '@components'

const Trash = (): ReactElement => {
  const { companyId } = useRequiredParams<WithCompanyId>()
  return <UserTrash companyId={companyId} />
}

export const Route = createFileRoute('/companies_/$companyId_/user_/trash/')({
  component: Trash,
})
